module.exports = __webpack_public_path__ + "img/home_1.2546149c.jpeg";